import Cookies from 'js-cookie'

export const getCookie = Cookies.get
export const setCookie = Cookies.set
export const removeCookie = Cookies.remove
